import { react2angular } from 'react2angular';
import BranchAccess from './view/BranchAccess';

angular
  .module('bb.users', ['angularjs-dropdown-multiselect'])
  .component(
    'branchAccess',
    react2angular(BranchAccess, [
      'branches',
      'setUserLocations',
      'userLocation',
      'userLocations',
    ]),
  );

require('./user.service');

require('./view/user_action_modal.component');
require('./group/group_list.controller');

require('./select/user_multi_select.directive');
require('./team/user_team_list.component');
require('./select/user_select.directive');

require('./list/advancedDropdown.component');

require('./group/group.routes');
require('./team/user_team.routes');
